<template>
	<div id="leftNav">
		<!-- 页面左侧导航 -->
		<div class="title" style="margin-bottom: 10px;">
			{{ $t("message.i18n_16") }}
			<div class="underline"><!-- 下划线样式，勿删 --></div>
		</div>
        <template v-for="(item,index) in leftMenuList">
            <div v-if="item.title" :key="index + 'index'">
                <div style="
				border-bottom: 1px solid #EBEBEB;
				line-height: 40px;
				padding-left: 10px;
				font-size: 14px;
				cursor: pointer;
				height: 40px;">
                    <router-link style="color: #000;text-decoration: none;" @click.native="clickLink(item.title)"
                                 :to=" item.type == 1 ? ('/page/singlepage/' + item.id ): item.type == 'home' ? '/' : item.type == 4 ? item.url : item.type == 2 ? ('/page/article_list/' + item.id ) : '/'" exact >
					<span :class="{'choose' : nowId == item.id}" style="white-space: nowrap;">
						{{item.title}}
					</span>
                        <!-- <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span> -->
                    </router-link>
                </div>
            </div>
        </template>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props:{
			leftMenuList: {
				type: Array,
				default: () => []
			},
			nowId: undefined
		},
		watch: {
			leftMenuList(newVal) {
				return newVal
			},
			nowId(newVal) {
				return newVal
			}
		},
		created() {

		},
        methods:{
            clickLink(name) {
                // console.log("leftNav.click", name)
                this.$emit("on-click", name)
            }
        }
	}
</script>

<style scoped>
	#leftNav .title {
		font-size: 22px;
		font-weight: normal;
		color: #545454;
		line-height: 50px;
		border-bottom: 1px solid #ebebeb;
		position: relative;
	}
	#leftNav .title .underline {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 86px;
		border-bottom: 1px solid #C71625;
	}

	.choose {
		color: #03b293;
	}
</style>



// WEBPACK FOOTER //
// src/components/leftNav.vue